import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../containers/App';

import * as COM from '.';

export const DatasetQuery = (props) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const auth = useContext(AuthContext);

    const init = async () => {
        setLoading(true);
        let data = await COM.fetchData(props, auth);
        setData(data);
        setLoading(false);
        if (props.onSuccess) {
            props.onSuccess(data);
        }
    }

    useEffect(() => {
        init();
    }, props.invalidateEffect ? props.invalidateEffect : []);

    if (props.children) {
        return props.children(loading, data, init);
    } else {
        return null;
    }
};